module.exports = __webpack_public_path__ + "img/marketplace-ribbon.f77b2fe7.svg";